export enum SettingPatchPaths {
    PageSaving = "assessment.pageSaving",
    LanguageChoice = "language.languageChoice",
    EmbedConsent = "privacy.embedConsent",
    Grades = "notifications.settings.grades",
    Feedback = "notifications.settings.feedback",
    Comments = "notifications.settings.comments",
    Updated = "notifications.settings.updated",
    Shares = "notifications.settings.shares",
    AtlasReceipts = "notifications.settings.atlasReceipts",
    NotificationFrequency = "notifications.settings.notificationFrequency",
    NotificationTime = "notifications.settings.notificationTime"
}
